import React, { useState, useEffect, useCallback } from "react";
import dummy_user from "../../../Assets/images/user_square.png";
import product_image from "../../../Assets/images/categoryimg.png";
import { reviewApi } from "../../../App/api/order.apis";
import { AiOutlineSearch } from "react-icons/ai";
import StoreCards from "./Cards/StoreCards";
import ProductCards from "./Cards/ProductCards";
import debounce from "lodash.debounce";
import styles from "./userreview.module.css";

const UserReview = ({ type, itemData }) => {
  const reviews = ["Product", "Store"];
  console.log("itemData:",itemData)

  const [toggleReview, setToggleReview] = useState(reviews[0]);
  const [reviewData, setReviewData] = useState([]);
  const [hasMore, setHasMore] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [searchReview, setSearchReview] = useState("");

  // Fetch reviews based on toggleReview state
  const getReviews = async (page, search = "") => {
    // console.log("search: " + search);
    setLoading(true);
    setError(null);
    setPage(1);
    setReviewData([]);
    // console.log("toggleReview: " + toggleReview);
    try {
      let res;
      if (toggleReview === reviews[0]) {
        // If it's the product, call product reviews API
        res = await reviewApi.getAllProductReviews(
          {
            page,
            limit: 4,
            filter: { created_by: itemData?._id },
          },
          search
        );
      } else {
        // Otherwise, call vendor reviews API
        res = await reviewApi.getAllVendorReviews(
          {
            page,
            limit: 4,
            filter: { created_by: itemData?._id },
            search,
          },
          search
        );
      }
      // console.log(" res", res?.data?.data?.ratingsReviews);
      // console.log("res?.data?.data?", res?.data?.data?.totalCount);
      setHasMore(res?.data?.data?.totalCount);
      setReviewData(res?.data?.data?.ratingsReviews || []); // Update review data
      setPage(page + 1);
    } catch (err) {
      setError("Failed to load reviews.");
      console.error("error", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch reviews when toggleReview changes
  useEffect(() => {
    getReviews(1);
    setSearchReview("");
  }, [toggleReview]);

  const loadMoreData = async () => {
    try {
      let res;
      if (toggleReview === reviews[0]) {
        // If it's the product, call product reviews API
        res = await reviewApi.getAllProductReviews(
          {
            page,
            limit: 4,
            filter: { "product_detail.created_by": itemData?._id },
          },
          searchReview
        );
      } else {
        // Otherwise, call vendor reviews API
        res = await reviewApi.getAllVendorReviews(
          {
            page,
            limit: 4,
            filter: { vendor: itemData?._id },
          },
          searchReview
        );
      }
      const newData = res?.data?.data?.ratingsReviews || [];
      // console.log(" res", res?.data?.data?.ratingsReviews);
      setReviewData((prev) => [...prev, ...newData]);
      setHasMore(res?.data?.data?.totalCount);
      setPage(page + 1);
    } catch (err) {
      setError("Failed to load reviews.");
      console.error("error", err);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useCallback(
    debounce((query) => getReviews(1, query), 1000),
    [toggleReview]
  );

  // console.log("searchreviwo", searchReview);
  const handleReviewSearchChange = (event) => {
    const query = event.target.value;
    setSearchReview(query);
    debouncedFetch(query);
  };

  return (
    <div className="container mx-auto h-full border  mt-2 bg-white shadow-lg rounded-[20px]">
      <div className="flex justify-center mt-2 mb-4">
        <span
          className={`flex justify-center items-center border border-[var(--color--2)] w-40 px-6 py-3 cursor-pointer rounded-l-[20px] transition-colors duration-300 ease-in-out 
        ${
          toggleReview == reviews[0]
            ? "bg-[var(--color--2)] text-white"
            : "text-[var(--color--2)]  "
        }`}
          onClick={() => {
            setPage(1);
            setToggleReview(reviews[0]);
          }}
        >
          {reviews[0]} Reviews
        </span>
        <span
          className={`flex justify-center items-center border border-[var(--color--2)] w-40 px-6 py-3 cursor-pointer rounded-r-[20px] transition-colors duration-300 ease-in-out 
        ${
          toggleReview == reviews[1]
            ? "bg-[var(--color--2)] text-white"
            : "text-[var(--color--2)] "
        }`}
          onClick={() => setToggleReview(reviews[1])}
        >
          {reviews[1]} Reviews
        </span>
      </div>
      <div className="flex flex-col items-center gap-2 border-b-2 pb-4">
        <p className="text-center font-semibold  text-xl text-[var(--text-color3)] ">
          Reviews of {toggleReview}
        </p>
        <div className="w-[80%] flex relative">
          <input
            type="text"
            placeholder="Search review..."
            className="border w-full outline-none rounded-full px-5  py-2 border-gray-400"
            onChange={handleReviewSearchChange}
          />
          <AiOutlineSearch className="absolute right-3 top-3" />
        </div>
      </div>

      <div
        className={`overflow-y-scroll p-6  scrollbarStrip h-[60%] ${styles.scrollbarStrip}`}
      >
        {toggleReview === "Store" ? (
          <StoreCards
            reviewData={reviewData}
            dummy_user={dummy_user}
            loadMoreData={loadMoreData}
            hasMore={hasMore}
          />
        ) : (
          <ProductCards
            reviewData={reviewData}
            dummy_user={product_image}
            loadMoreData={loadMoreData}
            hasMore={hasMore}
          />
        )}
      </div>
    </div>
  );
};

export default UserReview;
